<template>
    <div>
        <div v-if="fullScreenMode">
            <v-card>
                <v-card-text>
                    <v-img :src="fullScreenImage" contain></v-img>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-on:click="backToGallery" :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Back</v-btn>
                </v-card-actions>
            </v-card>
        </div>
        <div v-if="!fullScreenMode">
            <v-row>
                <v-col class="d-flex flex-column" md="4" cols="12" v-for="item in images" :key="item.name">
                    <v-card class="flex d-flex flex-column" fill-height height="350">
                        <v-card-text>
                            <v-hover v-slot:default="{ hover }">
                                <v-img :src="item.url" height="300" contain>
                                    <v-expand-transition>
                                        <div v-if="hover"
                                            class="d-flex transition-fast-in-fast-out grey darken-2 v-card--reveal display-1 white--text"
                                            style="height: 100%;">
                                            <v-row align="center" justify="center">
                                                <v-col></v-col>
                                                <v-col>
                                                    <v-btn :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'" v-on:click="setProfilePicture(item.name)">
                                                        Set
                                                        Profile Picture
                                                    </v-btn>
                                                    <v-btn class="mt-2" :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'" v-on:click="openFullScreen(item.url)">
                                                        Fullscreen
                                                    </v-btn>
                                                </v-col>
                                                <v-col></v-col>
                                            </v-row>
                                        </div>
                                    </v-expand-transition>
                                </v-img>
                            </v-hover>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <!-- <v-btn class="navColor">Set Profile</v-btn> -->
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import RestResource from '../RestResource.js';
import { mapActions } from 'vuex';
const restResourceService = new RestResource();

export default {
    name: "S3Gallery",
    setup() {

    },
    props: {
        albumName: String,
        isProfileSelection: Boolean,
        passS3ImageUrls: Array,
        refreshTrigger: Number,
    },
    components: {

    },
    data: () => ({
        images: [],
        imageLoading: false,
        openFileExplorer: false,
        currentImage: undefined,
        previewImage: undefined,
        progress: 0,
        message: "",
        imageInfos: [],
        imageExtentionsAllowed: ['image/png', 'image/jpeg'],
        loading: false,
        dialog: false,
        fullScreenMode: false,
        fullScreenImage: undefined,
    }),
    mounted: function () {
        if (this.$props.passS3ImageUrls == undefined)
            this.getAccountAlbum();
        else
            this.images = this.$props.passS3ImageUrls;
    },
    watch: {
        refreshTrigger: function () {
            console.log("TRIGGERED REFRESH");
            let timeout = parseInt(process.env.VUE_APP_refreshAfterUploadTimeMS);
            console.log(timeout)
            setTimeout(this.getAccountAlbum, timeout);
        }
    },
    methods: {
        ...mapActions([
            'fetchAccountDetails',
        ]),
        //Get the album images associated to the account
        async getAccountAlbum() {
            this.loading = true;
            this.images = await restResourceService.getAccountAlbum();
            this.images.reverse(); //newest first
            this.loading = false;
        },
        //Sets profile picture, stored in account detials
        async setProfilePicture(name) {
            const res = await restResourceService.setProfilePicture(name);

            if (res == 200) {
                this.fetchAccountDetails();
                this.$emit('snack', "Profile picture changed");
            }

        },
        openFullScreen(imageUrl) {
            this.fullScreenMode = true;
            this.fullScreenImage = imageUrl
        },
        backToGallery() {
            this.fullScreenMode = false;
        }

    },
}
</script>

<style scoped>
</style>